import { __parseDate } from '../../language/translate.js';
export function cleanMarkers(rg, num, type, lastDate) {
	var highestNum = new Array;

	let lastMarkerGroup = 0;
	let lastMarkerId = 0;

	var counts = 0;
	var index = 0;
	for (var i = 0; i < rg.length-1; i++) {
		if (rg[i]) {
			if ( 
				rg[i].group > 4 && rg[i-1].group > 4 && (rg[i + 1].group != rg[i].group && rg[i - 1].group != rg[i].group)
				) {
				rg.splice(i, 1);
				i--;
			}
			//find a pair
			if ((!!rg[i+1].label && rg[i+1].label.type == type) && rg[i+1].group > 4 && rg[i+1].group == rg[i].group) {	
				if (index == 0 || (index > 0 && i != highestNum[index]))	{
					highestNum.push(i+1);
					lastMarkerGroup = rg[i].group;
					lastMarkerId = i;
					index++;
				}   		
			}
		}
	}
	
	for (var i = highestNum.length-1; i >= 0; i--) {

		highestNum = graphBubbleSort(highestNum, rg, i);
	}
	
	// Cut the array after index of num
	if (type == 0) {
		if (num < highestNum.length) {
			highestNum = highestNum.slice(0,num);
		}
	} 
	if (type == 1) {
		if (highestNum.length-num >= 0) {
			highestNum = highestNum.slice(highestNum.length-num,highestNum.length);
		}
	}
	
	// sort it to have time axis back as order (instead of drop%)
	highestNum.sort();

	// push from the total counts to the reduced counts in correct order
	var returnGraph = [];
	var highindex = 0;
	var lastMarkerDrawn = false;

	for (var i = 0; i < rg.length; i++) {
		if (rg[i].group < 5) {
			returnGraph.push(rg[i]);
		}
		if (highindex < num && (!!rg[i].label && rg[i].label.type == type) && rg[i].group > 4) {	
			if (!isNaN(highestNum[highindex])) {
				if (rg[highestNum[highindex]].group == lastMarkerGroup) lastMarkerDrawn = true;
				returnGraph.push(rg[highestNum[highindex] - 1]);
				returnGraph.push(rg[highestNum[highindex] + 0]);
			}
			highindex++;
		}
		if ((!!rg[i].label && rg[i].label.type != type) && rg[i].group > 4) {
			returnGraph.push(rg[i-1]);
			returnGraph.push(rg[i]);
		}
	}

	// draw last marker if it is not drawn
	if (!lastMarkerDrawn) {
		if (!!rg[lastMarkerId+1] && (new Date(rg[lastMarkerId+1].x).getTime() - new Date(lastDate).getTime() > -24*60*60*1000)) {
			returnGraph.push(rg[lastMarkerId]);
			returnGraph.push(rg[lastMarkerId+1]);
		}
	}

	return returnGraph;
}

export function graphBubbleSort(arr, rg, n) {
	for (var i = 0; i < n - 1; i++) {
		if (parseFloat(rg[arr[i]].label.content) > parseFloat(rg[arr[i+1]].label.content)) {
			var temp = arr[i];
			arr[i] = arr[i + 1];
			arr[i + 1] = temp;
		}
	}
	return arr;
}

export function check_svg_mouse_hover(BBox, loc) {
	if (loc.x > BBox.x && loc.x < BBox.x+BBox.width && 
		loc.y > BBox.y && loc.y < BBox.y+BBox.height )
	{
		return true;
	}
	else {
		return false;
	}
}

export function saveEncodeDate(input) {
	if (typeof(input) != "string") return input;
	if (input.split(/[- :]/).length) {
		var _arr = input.split(/[- :]/),
		_date = new Date(_arr[0], _arr[1]-1, _arr[2], _arr[3], _arr[4], _arr[5]);
		return _date;
	} else {
		return input;
	}	
}

export function getYearMonthDayAsString(date) {
	var return_str = (new Date(date).getFullYear()).toString();
	if (new Date(date).getMonth()+1 < 10) return_str += "0"; 
	return_str += (new Date(date).getMonth()+1).toString();
	if (new Date(date).getDate() < 10) return_str += "0";
	return_str += (new Date(date).getDate()).toString();
	return return_str;
}

export function getNumMarkers(array, type) {
	var counter = 0;
	array.forEach(function (item, ix) {
		if (!!item["group"] && item["group"] > 2 && !!item.label && item.label.type == type)
			counter++;
	});
	return counter;
}

export function groupChartData(ads, chartType) {
	if (!!ads) {
        var jsItemString = "";
        var return_array = new Array();
     	ads.forEach(function(item) {			
			if (parseFloat(item.price) > 0) {
				var _ = {};
				_['x'] = item.datetime.toString();
				_['y'] = item.price.toString();
				_['group'] = 0;
				_['chartType'] = chartType;
				return_array.push(_); 
			} 			 
		}) 
		return return_array;
	}
}

/* remove duplicated prices with in a day */
export function filterOutDuplicatesInPrices (items) {
	var previousPrice = -1;
	var beforePreviousPrice = -1;
	var prevoiusDate = -1;
	return items.filter((item) => {
		if (previousPrice == -1 || beforePreviousPrice == -1) {
			if (previousPrice == -1) {
				previousPrice=item.y;
			} else {
				beforePreviousPrice = previousPrice;
				previousPrice=item.y;
			}
			prevoiusDate = item.x;
			return item;
		} else {
			let this_day = new Date(item.x.slice(0, -1)).getDay();
			let day_from_previous = new Date(prevoiusDate.slice(0, -1)).getDay();
			prevoiusDate = item.x;
			if (this_day != day_from_previous) {
				beforePreviousPrice = previousPrice;
				previousPrice=item.y;
				return item;
			} else {
				if (item.y != beforePreviousPrice && beforePreviousPrice != previousPrice) {
					beforePreviousPrice = previousPrice;
					previousPrice=item.y;
					return item;
				}
			}
		}
	});
}

/* 
	 * Filter out dates by timescope
	 * @param {Array} items - array of data
	 * @param {Number} timescope - timescope in hours
	 * @return {Array} - filtered array
*/
export function filterOutDatesByTimescope (items, timescope) {
	var previousDate = -1;
	var diff_array = new Array();
	return items.filter((item) => {
		if (previousDate == -1) {
			previousDate=item.x;
			diff_array.push(item);
			return item;
		} else {
			diff_array.push(item);
			if (new Date(item.x).getTime()-new Date(previousDate).getTime()>=1000*30*timescope) {
				var return_array = new Array();
				return_array.push(diff_array.reduce((prev, current) => (prev.y > current.y) ? prev : current));
				return_array.push(diff_array.reduce((prev, current) => (prev.y < current.y) ? prev : current));
				previousDate=item.x;
				diff_array = [];
				return return_array;
			}
		}
	});
}

export function getAvrgOfNumArray(array) {
	var sum = 0;

	for (var i=0;i<array.length;i++) {
		sum+= parseFloat(array[i].y);
	}
	return parseFloat(sum/array.length);
}

export function offsetGraphGroups(array, offset) {
	var return_array = new Array();
	array.forEach(function (item, ix) {
		if (!item["group"]) {
			return_array.push(item);
		}
		if (!!item["group"] && item["group"] >= 0) {
			item.group += offset;
			return_array.push(item);
		}
	});
	return return_array;
}

export function getGraphById(id) {
	var return_graph = rendered_graphs.filter(graph => graph.id == id);
	if (return_graph.length) return return_graph[0];
	else return false;
}

export function deleteGraphById(id) {
	rendered_graphs = rendered_graphs.filter( el => el.id.toString() != id.toString() ); 
};

export function disableZoomableOnAllGraphs() {
	rendered_graphs.forEach(function(_graph, ix) {
		_graph.obj.range.options.zoomable = false;
		_graph.obj.range.options.moveable = false;
		$('#' + 'visualization_' + _graph.id).parent().find('.graph-click').css("visibility", "visible");
	})
}

export function updateGraph(ix) {
	var vis_width = $('#' + 'visualization_' + ix).width();
	var vis_height = vis_width * 0.5;
	if (vis_width < 600) vis_height = vis_width * 0.6;
	let _graph = getGraphById(ix);
	if (!!_graph) _graph.obj.height = vis_height;
}

export function enableGraphZoomableById(ix) {
	let _graph = getGraphById(ix);
	_graph.obj.range.options.zoomable = true;
	_graph.obj.range.options.moveable = true;
	/*_graph.obj.on("panmove", function() {
		this.redraw();
	})
	*/
	$('#' + 'visualization_' + _graph.id).parent().find('.graph-click').css("visibility", "hidden");
}

export function transformSVALtoTimescope(sval) {
	if (sval == 1) return 60;
	if (sval == 2) return 24;
	if (sval == 3) return 12;
	if (sval == 4) return 6;
	if (sval == 5) return 3;
	if (sval == 6) return 1;
}

export function mergeChartData(oldData, newData) {
	if (!oldData) return newData;
	if (!newData) return oldData;
	let arr = oldData.concat(newData);
	let mergedArr = [...new Set(arr)];
	mergedArr.sort((a,b) => {
		return new Date(__parseDate(a.x)).valueOf() - new Date(__parseDate(b.x)).valueOf()
	})
	return mergedArr;
}